export const BASE_PATHS = {
    TEST: 'https://s.zillow.net',
    PROD: 'https://s.zillowstatic.com',
};
